import { signInAppModule } from './app-sign-in.module';
export const loadSignInAngularJsAppShell = (): angular.IModule => signInAppModule;
